import { ChevronDown } from 'lucide-react';

import { Flex } from '@/components/base';
import Button from '@/components/Button/Button';
import Menu from '@/components/Menu/Menu';
import { FeedbackSentiment, sentimentMap } from '@/types/feedbackConst';

type Props = {
  value: FeedbackSentiment;
  onChange: (value: FeedbackSentiment) => void;
};

export const CellCalculationSelect = (props: Props) => {
  const { value, onChange } = props;
  return (
    <Flex j="flex-end" a="center">
      <Menu
        modalWidth={200}
        triggerNode={
          <Button
            className="-mr-2"
            variant="ghost"
            sizeType="m"
            rightIcon={<ChevronDown className="size-3 text-gray-600" />}
          >
            {sentimentMap[value]?.value}
          </Button>
        }
        options={[
          {
            label: 'Negative',
            onClick: () => onChange(FeedbackSentiment.NEGATIVE),
          },
          {
            label: 'Positive',
            onClick: () => onChange(FeedbackSentiment.POSITIVE),
          },
        ]}
      />
    </Flex>
  );
};
